import React from "react";
import { Table } from "components";
import PropTypes from "prop-types";
import { Row, Col, Button } from "antd";
import { List, OrderedMap } from "immutable";
import { onCellGenerator } from "constants/table-columns";
import { TABLE_DATA_TYPES } from "constants/table-data-types";
import axios from "../../../node_modules/axios/index";

const LEDGER_MASTER_COLS = new OrderedMap({
    Date: {
        title: "Date",
        dataIndex: "create_date",
        key: "create_date",
        editable: false,
        onCellGenerator,
        dataType: TABLE_DATA_TYPES.STRING,
    },
    Document: {
        title: "Document",
        dataIndex: "document_name",
        key: "document_name",
        editable: false,
        onCellGenerator,
        dataType: TABLE_DATA_TYPES.STRING
    },
    Action: {
        title: "Action",
        dataIndex: "file",
        key: "file",
        render: function getDocument(document_name, file) {
            return <Button onClick={() => {downloadFile(file, document_name);}} >Download</Button>;
        },
    },
});

const downloadFile = (url,document_name) => {
    var filename = url.document_name;
    if(url.document_type=="WelcomePdf"){
        filename = `${url.document_name}.pdf`;
    }
    axios({
        url: document_name,
        method: "GET",
        responseType: "blob",
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
    });

};

class VisibilitySheet extends React.Component {

    componentDidMount() {
        this.props.fetchCompanyVisibilitySheetData(this.props.companyId);
    }
    
    render() {
        return (
            <Row>
                <Col offset={3} span={18} className={"mb-10"}>
                    <Table
                        showFilters={false}
                        columns={LEDGER_MASTER_COLS.map(({ onCellGenerator, editable, ...restColFields}) => {
                            if (!onCellGenerator || !editable) {
                                return { ...restColFields };
                            }
                            return {
                                onCell: onCellGenerator(
                                    this.handleSaveMultipleEntries,
                                    restColFields
                                ),
                                ...restColFields
                            };
                        })}
                        showTopSection={false}
                        noRowSelection={true}
                        data={new List(this.props.visibilitySheetData) || new List([{}])}
                        editable={true}
                        pagination={false}
                        //onFilter={this.onFilter}
                        tablePagination={true}
                        visibilitySheetData={this.props.visibilitySheetData}
                    />
                </Col>
            </Row>
        );
    }

}

VisibilitySheet.propTypes = {
    companyId: PropTypes.number,
    visibilityData: PropTypes.func,
    fetchCompanyVisibilitySheetData: PropTypes.func,
    visibilitySheetData: PropTypes.func,
    visibilitySheetDataStatus: PropTypes.string,
};

export default VisibilitySheet;